/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Command_PlaceholderInputs */

const he_command_placeholder = /** @type {(inputs: Command_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הקלידו פקודה או חפשו...`)
};

const en_command_placeholder = /** @type {(inputs: Command_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a command or search...`)
};

/**
* | output |
* | --- |
* | "Type a command or search..." |
*
* @param {Command_PlaceholderInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const command_placeholder = /** @type {((inputs?: Command_PlaceholderInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Command_PlaceholderInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_command_placeholder(inputs)
	return en_command_placeholder(inputs)
});